var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.4285C12 11.9968 11.7629 12.5419 11.341 12.9437C10.919 13.3456 10.3467 13.5714 9.75 13.5714C9.15326 13.5714 8.58097 13.3456 8.15901 12.9437C7.73705 12.5419 7.5 11.9968 7.5 11.4285C7.5 10.8602 7.73705 10.3151 8.15901 9.91327C8.58097 9.51141 9.15326 9.28564 9.75 9.28564C10.3467 9.28564 10.919 9.51141 11.341 9.91327C11.7629 10.3151 12 10.8602 12 11.4285V11.4285Z",
    fill: "#4A5568"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C5.20435 5 4.44129 5.30102 3.87868 5.83684C3.31607 6.37266 3 7.09938 3 7.85714V22.1429C3 22.9006 3.31607 23.6273 3.87868 24.1632C4.44129 24.699 5.20435 25 6 25H24C24.7956 25 25.5587 24.699 26.1213 24.1632C26.6839 23.6273 27 22.9006 27 22.1429V7.85714C27 7.09938 26.6839 6.37266 26.1213 5.83684C25.5587 5.30102 24.7956 5 24 5H6V5ZM24 6.42857C24.3978 6.42857 24.7794 6.57908 25.0607 6.84699C25.342 7.1149 25.5 7.47826 25.5 7.85714V17.1429L19.8345 14.3614C19.6938 14.2943 19.5346 14.271 19.3792 14.2949C19.2239 14.3187 19.0804 14.3885 18.969 14.4943L13.404 19.7943L9.414 17.2629C9.26994 17.1715 9.09714 17.1304 8.92491 17.1466C8.75267 17.1627 8.5916 17.2351 8.469 17.3514L4.5 20.7143V7.85714C4.5 7.47826 4.65804 7.1149 4.93934 6.84699C5.22064 6.57908 5.60218 6.42857 6 6.42857H24Z",
    fill: "#4A5568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadImage);
export default __webpack_public_path__ + "static/media/DownloadImage.602567e3ede7c5bc19f1b44c0c8fae00.svg";
export { ForwardRef as ReactComponent };